import React from "react";
import stylesLess from "./index.module.less";

import Nav from "./Nav";
import Foot from "./Foot";

import imgBackground_dark from "assets/images/newbackground-dark.jpg";
import imgBackground_light from "assets/images/newbackground-light.jpg";

/** showNav: 是否显示主 header（logo+语言等），false 时为仅返回栏（页面内自绘返回按钮） */
export default function Layout({ children, showNav = true }) {
  const style = {};
  return (
    <div className={`${stylesLess.page}`} style={style}>
      <div>
        {showNav ? <Nav className={stylesLess.nav} /> : null}
        <div className={stylesLess.main}>{children}</div>
      </div>
    </div>
  );
}
